import { render, staticRenderFns } from "./DownloadChain.vue?vue&type=template&id=f39fe180&"
import script from "./DownloadChain.vue?vue&type=script&lang=js&"
export * from "./DownloadChain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports